// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"397":"0e0501aa","982":"f49666d6"}[chunkId] + ".chunk.js";
};